import {PLATFORM_AREA, COMPONENT_ID, RIA_COMPONENT} from '@advisor/util/constants';

export default [
  {
    // Home
    path: '/advisor',
    name: 'Home',
    redirect: {name: 'Overview'},
  },
  {
    // Home: Summary
    path: '/advisor/summary',
    name: 'Overview',
    component: () => import('@advisor/components/dashboard/Overview'),
    meta: {
      breadCrumbs: {
        to: '/summary',
        text: '',
        title: 'Dashboard',
        componentId: 1,
      },
      platformArea: PLATFORM_AREA.DASHBOARD,
      visibilityComponentId: COMPONENT_ID.DASHBOARD,
      riaComponent: RIA_COMPONENT.DASHBOARD,
    },
  },
];
